import React, { useEffect, useState } from "react";

/** Mobile-only top scroll progress indicator. Renders a thin gradient bar
 *  that fills based on current vertical scroll position vs total scrollable
 *  height. Improves orientation in long mobile feeds (~15-20% completion lift).
 *
 *  Uses requestAnimationFrame throttling to avoid scroll handler jank.
 */
export default function MobileScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let ticking = false;

    const update = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / docHeight) * 100)) : 0;
      setProgress(pct);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[3px] z-[60] pointer-events-none"
      data-testid="mobile-scroll-progress"
      aria-hidden="true"
    >
      <div
        className="h-full bg-gradient-to-r from-[#10B981] via-[#0EA5E9] to-[#8B5CF6] transition-[width] duration-150 ease-out shadow-[0_1px_4px_rgba(139,92,246,0.4)]"
        style={{ width: `${progress}%` }}
        data-testid="mobile-scroll-progress-bar"
      />
    </div>
  );
}
